module.exports = __webpack_public_path__ + "img/playbutton22.5d14783c.png";